var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"mars-ape-layout"},[_c('el-main',{class:`${_vm.$route.name}_main`},[_c('div',{class:`${_vm.$route.name}_main-inner`,staticStyle:{"display":"flex","flex-direction":"column"}},[_c('router-view',{class:`${_vm.$route.name}_main-inner__content`})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }